<select [(ngModel)]="selectedMethod" class="form-select">
  <option [value]="0">Select a calculation method</option>
  <option  *ngFor="let method of methods" [value]="method.name" [innerText]="method.alias" ></option>
</select>
